import { webapi } from '@/api/webapi.ts';
import { getPinnedCompanies } from '@/api/workspace/endpoints/getPinnedCompanies.ts';
import { getSharedTabListQuery } from '@/api/workspace/endpoints/getShareTabListQuery.ts';
import { getSharedTabQuery } from '@/api/workspace/endpoints/getShareTabQuery.ts';
import { getWorkspace } from '@/api/workspace/endpoints/getWorkspace.ts';
import { pinCompaniesMutation } from '@/api/workspace/endpoints/pinCompaniesMutation.ts';
import { saveWorkspace } from '@/api/workspace/endpoints/saveWorkspace.ts';
import { shareTabMutation } from '@/api/workspace/endpoints/shareTabMutation.ts';
import { stopSharingMutation } from '@/api/workspace/endpoints/stopSharingMutation.ts';

export const WORKSPACE_VERSION = 3;

export const workspaceApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspace: getWorkspace(builder),
    saveWorkspace: saveWorkspace(builder),
    getPinnedCompanies: getPinnedCompanies(builder),
    pinCompanies: pinCompaniesMutation(builder),
    getSharedTabList: getSharedTabListQuery(builder),
    getSharedTab: getSharedTabQuery(builder),
    shareTab: shareTabMutation(builder),
    stopSharing: stopSharingMutation(builder),
  }),
});

export const {
  useQuery: useWorkspaceQuery,
  matchFulfilled: getWorkspaceMatchFulfilled,
  select: selectGetWorkspace,
} = workspaceApi.endpoints.getWorkspace;

export const {
  useQuery: useGetPinnedCompaniesQuery,
  matchFulfilled: getPinnedCompaniesMatchFulfilled,
  select: selectPinnedCompaniesQueryResult,
} = workspaceApi.endpoints.getPinnedCompanies;

export const { useMutation: usePinCompaniesMutation } = workspaceApi.endpoints.pinCompanies;

export const { useMutation: useSaveWorkspaceMutation, select: selectSaveWorkspaceMutation } =
  workspaceApi.endpoints.saveWorkspace;

export const { useQuery: useGetSharedTabListQuery } = workspaceApi.endpoints.getSharedTabList;
